import { ActivatedRoute } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry, PageScope, } from '@app/router';
import { TranslateService } from '@ngx-translate/core';
import { decodeBase64UTF16 } from '@utils/encode.utils';
import { MONITORING_FQN } from '@utils/queryParam.utils';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import flatMap from 'lodash-es/flatMap';
import { BehaviorSubject, combineLatest, } from 'rxjs';
import { map, startWith, tap, } from 'rxjs/operators';
var UiBreadCrumbsComponent = /** @class */ (function () {
    function UiBreadCrumbsComponent(_translateService, _appState, _pageRegistry, _route) {
        var _this = this;
        this._translateService = _translateService;
        this._appState = _appState;
        this._pageRegistry = _pageRegistry;
        this._route = _route;
        this.PageScope = PageScope;
        this.pageScopeIcon$ = new BehaviorSubject(PageScope.Global);
        this.breadcrumbs$ = combineLatest([
            this._appState.user.folder.value$,
            this._pageRegistry.activePage$.pipe(filterNullOrUndefined(), tap(function (p) { return _this.pageScopeIcon$.next(p.scope); })),
            this._route.queryParamMap.pipe(map(function (route) { return route.get(MONITORING_FQN); }), map(function (fqn) { return fqn ? decodeBase64UTF16(fqn) : undefined; })),
            this._appState.language.value$,
        ]).pipe(map(function (_a) {
            var folder = _a[0], activePage = _a[1], fqnParam = _a[2];
            var folderPath = fqnParam
                ? _this._extractPathFromString(fqnParam)
                : _this._extractFolderPath(folder);
            var routePath = _this.extractRoutePath(activePage);
            if (!folderPath.length) {
            }
            else if (routePath.length) {
                folderPath[folderPath.length - 1].value += ':';
            }
            return folderPath.concat(routePath);
        }), startWith([]));
        this.tooltip$ = this.breadcrumbs$.pipe(map(function (breadcrumbs) { return breadcrumbs.map(function (b) { return b.value; }).join(' '); }));
    }
    UiBreadCrumbsComponent.prototype.extractRoutePath = function (page) {
        if (!page.translationKey) {
            return [];
        }
        var path = [];
        while (true) {
            path.push({
                type: 'text',
                value: this._translateService.instant(page.translationKey),
            });
            if (!page.parent) {
                break;
            }
            path.push({ type: 'punctuation', value: '>' });
            page = page.parent;
        }
        return path.reverse();
    };
    UiBreadCrumbsComponent.prototype._extractFolderPath = function (f) {
        if (!this._appState.user.folder.hasAny || this._pageRegistry.activePage.scope === PageScope.Global) {
            return [];
        }
        return this._extractPathFromString(f.fullyQualifiedName);
    };
    UiBreadCrumbsComponent.prototype._extractPathFromString = function (path) {
        return flatMap(path.split('/'), function (value) { return [{ type: 'punctuation', value: '/' }, { type: 'text', value: value }]; }).slice(1);
    };
    return UiBreadCrumbsComponent;
}());
export { UiBreadCrumbsComponent };
